module.exports = __webpack_public_path__ + "static/media/detalle.529d6533.svg";